import { useEffect } from "react";
import LoginBankid from "../../../../login/content/bankid";
import LoginCode from "../../../../login/content/code";
import LoginMain from "../../../../login/content/main";
import LoginStart from "../../../../login/content/start";
import { useLogin } from "../../../../login/context/LoginContext";

export default function AccountStep() {
  const LoginContext = useLogin();

  useEffect(() => {
    LoginContext.setData(prev => ({ ...prev, no_redirect: true }));
  }, []);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <div className="max-h-[350px] max-w-[450px]">
        {LoginContext.view === "start" && <LoginStart />}
        {LoginContext.view === "bankid" && <LoginBankid />}
        {LoginContext.view === "code" && <LoginCode />}
        {LoginContext.view === "main" && <LoginMain />}
      </div>
    </div>
  );
}
